import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ChevronRightOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchMainMenu } from "./Reducers/actions";
import { getPWAMainMenuAction } from "./API/action";

export default function MainMenuScreen() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const dispatch = useDispatch();
  const { menuItems = [], banners=[] } = useSelector((state) => state?.mainMenuReducer || {});

  useEffect(() => {
    dispatch(fetchMainMenu());
  }, [dispatch]);

  const isSingleBanner = banners.length <= 1;
  const sliderSettings = {
    dots: false,
    infinite: !isSingleBanner,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: !isSingleBanner,
    autoplaySpeed: 3000,
    draggable: !isSingleBanner,
    swipe: !isSingleBanner,
  };

  return (
    <Box sx={{ p: 2 }}>
      {banners.length > 0 && (
        <Slider {...sliderSettings}>
          {banners.map((banner) => (
            <Box key={banner?.id} sx={{ px: 1, pt: 2, pb: 5 }}>
              <img
                src={banner?.src}
                alt={banner?.altText || "banner"}
                style={{
                  width: "100%",
                  height: isMobile ? "auto" : '400px',
                  borderRadius: 12,
                  objectFit: isMobile ? "cover" : "contain",
                }}
              />
            </Box>
          ))}
        </Slider>
      )}

      {/* Menu */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="body1" sx={{ mb: 2, fontWeight: "bold" }}>
          Select from below to view
        </Typography>
        <List>
          {menuItems.map((item, index) => (
            <ListItem
              key={index}
              button
              onClick={() => navigate(item.path)}
              sx={{
                borderBottom: "1px solid #e0e0e0",
                py: 2,
              }}
            >
              <ListItemIcon>
                <img
                  src={item.icon}
                  alt={item.label}
                  style={{ width: 24, height: 24 }}
                />
              </ListItemIcon>
              <ListItemText primary={item.label}
               primaryTypographyProps={{
                  sx: {
                    color: '#595959',
                    fontWeight: "bold",
                  },
                }} 
              />
              <ChevronRightOutlined sx={{ color: "#9CA3AF" }} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
}
